import React from 'react';
import { GenericModal } from 'src/components/Modals/GenericModal';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Divider, FormGroup } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import CheckboxItem from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/CheckboxItem';
import { useAccuracyFilterStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/stores/AccuracyFilterStore';

const AccuracyFilterModal = () => {
  const {
    isOpen,
    tempFilters,
    closeModal,
    setTempFilter,
    resetFilters,
    applyFilters
  } = useAccuracyFilterStore();

  const handleApply = () => {
    applyFilters();
  };

  const handleClear = () => {
    resetFilters();
  };

  return (
    <GenericModal
      open={isOpen}
      onClose={closeModal}
      sx={{
        '& .MuiPaper-root': {
          padding: '18px 24px 16px 24px',
          width: '450px'
        },
        '& .genericModal__body': {
          height: '372px'
        },
        '& .genericModal__header': {
          position: 'relative',
          paddingBottom: '18px',
          justifyContent: 'center',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '-24px',
            width: 'calc(100% + 48px)',
            height: '1px',
            backgroundColor: colors.graysSecondary
          },
          '& h4': {
            width: '100%',
            textAlign: 'center'
          },
          svg: {
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-100%)'
          }
        }
      }}
    >
      <GenericModal.Header title="Accuracy Filter" onClose={closeModal} />
      <GenericModal.Body>
        <Flex flexDirection="column" gap={24} sx={{ padding: '24px 0 40px' }}>
          <Text variant="body2">Use the filters below to view products with low content accuracy scores.</Text>

          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}
          >
            <CheckboxItem
              checked={tempFilters.titleInaccuracies}
              onClick={(e) => setTempFilter('titleInaccuracies', e.target.checked)}
              label="Title inaccuracies"
              value="titleInaccuracies"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.bulletInaccuracies}
              onClick={(e) => setTempFilter('bulletInaccuracies', e.target.checked)}
              label="Bullet inaccuracies"
              value="bulletInaccuracies"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.descriptionInaccuracies}
              onClick={(e) => setTempFilter('descriptionInaccuracies', e.target.checked)}
              label="Description inaccuracies"
              value="descriptionInaccuracies"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.imageInaccuracies}
              onClick={(e) => setTempFilter('imageInaccuracies', e.target.checked)}
              label="Image inaccuracies"
              value="imageInaccuracies"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.videoInaccuracies}
              onClick={(e) => setTempFilter('videoInaccuracies', e.target.checked)}
              label="Video inaccuracies"
              value="videoInaccuracies"
              textSx={{ maxWidth: 'unset' }}
            />
          </FormGroup>
        </Flex>
      </GenericModal.Body>
      <Divider
        sx={{
          margin: '0 -24px',
          width: 'calc(100% + 48px)'
        }}
      />
      <Flex
        gap={16}
        justifyContent="space-between"
        sx={{
          paddingTop: '16px'
        }}
      >
        <SlButton onClick={handleClear}>Clear</SlButton>
        <SlButton onClick={handleApply} variant="contained">
          Apply
        </SlButton>
      </Flex>
    </GenericModal>
  );
};

export default AccuracyFilterModal; 